import {Component, Directive, ViewEncapsulation} from '@angular/core';

@Directive({
  selector: 'cyb-nav-menu-item',
  host: {'class': 'cyb-nav-menu-item'}
})
export class CybNavMenuItemDirective {}

@Component({
  selector: 'cyb-nav-menu',
  template: `<ng-content></ng-content>
`,
  styles: [`.cyb-nav-menu{z-index:2;padding:0;font-size:17px;color:#00b6c7;margin-top:30px;text-shadow:0 1px 0 #fff;display:block;box-sizing:border-box}.cyb-nav-menu-item{width:100%;overflow:hidden;color:#00b6c7;text-decoration:none;cursor:pointer;background-color:transparent;box-sizing:border-box;vertical-align:bottom;text-align:-webkit-match-parent;padding-left:0;margin-bottom:0;font-size:17px;outline:0}.cyb-nav-menu-item+.cyb-nav-menu-item::before{content:"|";margin:0 10px 0 5px;cursor:auto;vertical-align:bottom;color:#18b4bb}.cyb-nav-menu-item.active,.cyb-nav-menu-item:hover{color:#003245}`],
  encapsulation: ViewEncapsulation.None,
  host: {class: 'cyb-nav-menu'}
})

export class CybNavMenuComponent {}
